import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/dashboard/List'

const Dashboard = ({ location, match, currentUser }) => {
  if (location.pathname === '/dashboard') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-dashboard-read') > -1) {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }

  return ''
}

Dashboard.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Dashboard
